import type { DefaultMantineColor } from '@any-ui-react/core';
import { Badge, type BadgeProps } from '@mantine/core';

import { McpConnectionStatus } from '@/common/graphql';

export const McpConnectionStatusLabels: Record<McpConnectionStatus, string> = {
  [McpConnectionStatus.Active]: 'Active',
  [McpConnectionStatus.Expired]: 'Expired',
  [McpConnectionStatus.Revoked]: 'Revoked',
};

const McpConnectionStatusColors: Record<McpConnectionStatus, DefaultMantineColor> = {
  [McpConnectionStatus.Active]: 'green',
  [McpConnectionStatus.Expired]: 'gray',
  [McpConnectionStatus.Revoked]: 'red',
};

interface Props extends BadgeProps {
  status: McpConnectionStatus;
}

export const McpConnectionStatusBadge = ({ status, ...rest }: Props) => (
  <Badge {...rest} color={McpConnectionStatusColors[status]}>
    {McpConnectionStatusLabels[status]}
  </Badge>
);
